var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-4 pb-3 mt-5"},[_c('div',{staticClass:"h3 text-capitalize mb-0 text-start"},[_vm._v(" "+_vm._s(_vm.translateApiLabel(_vm.item.title))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }